export default __webpack_public_path__ + "static/media/automated-marketing-tools-mobile.eb479309.png";